export const CDN_URL = "https://d22y9kx9wskw4z.cloudfront.net";
